import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, FormCheckbox, FormSelect, Row, FormGroup } from 'shards-react'
import { actions, setFormData } from '../../../../redux/reducers/SummGraduatesHEO/summGraduatesHEOReducer';
import styles from '../styles.module.css'
import { organizationList } from '../../../../redux/reducers/organization-list-reducer'
import { getSchoolYearsList } from '../../../../utils/smallHelpers';
import { ORG_TYPES } from '../../../../constants/const';


const year = new Date().getFullYear();
const yearsList = getSchoolYearsList(year - 6, year, 'reverse');

const Form = ({ form }) => {
  
  const dispatch = useDispatch()

  const orgList = useSelector(state => state.reports.orgList.data)
  const auth = useSelector(state => state.auth.data)

  useEffect(() => {
    if (orgList !== undefined && orgList.length === 0) {
      dispatch(organizationList.organizationListRequestStart(auth))
    }
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    dispatch(setFormData({ ...form, [name]: value }))
  }

  const onSubmit = () => {
    dispatch(actions.reportRequestStart())
  }

  return (
    <Row className={styles.formRow}>
        
        <Col md={2}>
          <label htmlFor="year">Выберите год</label>
          <FormSelect
              id='year'
              name='year'
              size="sm"
              value={form.year}
              onChange={handleChange}
          >
              {yearsList.map(year => <option key={year} value={year} selected={year === form.year}>{year}</option>)}
          </FormSelect>
        </Col>

        <Col md={2}>
            <label htmlFor='_school'>Тип ОО</label>
            <FormSelect
              name='school'
              id='_school'
              size='sm'
              className='md-block'
              onChange={handleChange}
              value={form.school}
            >
              {ORG_TYPES.map(({name, value}) => <option key={value} value={value}>{name}</option>)}
            </FormSelect>
        </Col>

        <Button onClick={onSubmit}>Создать отчет</Button>

    </Row>
  )
}

export default Form